import * as myConstClass from './fileWithConstants';

export const Footer = () =>
  <div style={{ textAlign: "center" }}>
    <em>{myConstClass.FOOTER_TEXT}</em>
  </div>;